import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "icon-arrow",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "currentColor" }, [
      _createElementVNode("path", { d: "M22.75 12c0 5.93-4.82 10.75-10.75 10.75S1.25 17.93 1.25 12 6.07 1.25 12 1.25 22.75 6.07 22.75 12m-20 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12" }),
      _createElementVNode("path", { d: "M12.75 8.5v6c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-6c0-.41.34-.75.75-.75s.75.34.75.75" }),
      _createElementVNode("path", { d: "M15.75 12.5c0 .19-.07.38-.22.53l-3 3c-.29.29-.77.29-1.06 0l-3-3a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0L12 14.44l2.47-2.47c.29-.29.77-.29 1.06 0 .15.15.22.34.22.53" })
    ], -1)
  ]))]))
}
export default { render: render }